import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

const syncActiveTenant = (userData) => {
  if (!userData) return;

  const tenantId = userData.active_tenant_id || userData.tenant_id || null;
  const tenantName = userData.active_tenant_name || null;
  const tenantSlug = userData.active_tenant_slug || null;
  const isPlatformAdmin = !!userData.is_platform_admin;

  if (tenantId) {
    const currentTenantId = localStorage.getItem('active_tenant_id');
    if (!currentTenantId || !isPlatformAdmin) {
      localStorage.setItem('active_tenant_id', String(tenantId));
    }
  }

  if (tenantName && (!localStorage.getItem('active_tenant_name') || !isPlatformAdmin)) {
    localStorage.setItem('active_tenant_name', tenantName);
  }

  if (tenantSlug && (!localStorage.getItem('active_tenant_slug') || !isPlatformAdmin)) {
    localStorage.setItem('active_tenant_slug', tenantSlug);
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(authService.getCurrentUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (authService.isAuthenticated()) {
        try {
          const userData = await authService.getMe();
          syncActiveTenant(userData);
          setUser(userData);
        } catch (error) {
          console.error('Failed to fetch user:', error);
          authService.logout();
          setUser(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (username, password) => {
    await authService.login(username, password);
    const userData = await authService.getMe();
    syncActiveTenant(userData);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};
